import common from "../../utill/Common";

class AepsService {
  report = async (
    token,
    from_date,
    to_date,
    status,
    aeps_type,
    service_type,
    user_id,
    search_text,
    page,
    size
  ) => {
    const url = common.baseUrl + "admin/aeps/report";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date,
        to_date,
        search_text,
        status,
        aeps_type,
        service_type,
        user_id,
        page,
        size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  summary = async (
    token,
    from_date,
    to_date,
    user_id,
    aeps_type,
    service_type
  ) => {
    const url = common.baseUrl + "admin/aeps/summary";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date,
        to_date,
        user_id,
        aeps_type,
        service_type,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AepsService();
